import { useEffect, useState } from "react";
import Filters from "./components/Filters";

// Otis Admin PRO React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

function DataQualityLayout() {

    //const [dropItems, setDropItems] = useState(null); // State for selected event
    // useEffect(() => {    
    //     setDropItems(filter.dataSourceMapping);
    // }, []);
    
    return (
        <DashboardLayout>
            {Filters()}
        </DashboardLayout>
    );
}

export default DataQualityLayout;